import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { useState } from 'react';
import '../UI/UserMenu.css';
import profileIcon from '../../assets/ProfileIcon.png';
import logoutIcon from '../../assets/LogoutIcon.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleDown } from '@fortawesome/free-solid-svg-icons';
import { useUserAuth } from '../../context/UserAuthContext';
import { useNavigate, Link } from 'react-router-dom';
import LoadingModal from '../UI/LoadingModal';

export default function UserMenu() {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleLogout = async () => {
    setAnchorEl(null);
    setIsLoading(true);
    await logOut();
    setIsLoading(false);
    navigate("/");
  };
  const handleLogin = async () => {
    setAnchorEl(null);
    // setIsLoading(true);
    // await logOut();
    // setIsLoading(false);
    navigate("/login");
  };

  const { currentUser, logOut } = useUserAuth();

  return (
    <>
      <div>
        <Button
          id="basic-button"
          aria-controls={open ? 'basic-menu' : undefined}
          aria-haspopup="true"
          aria-expanded={open ? 'true' : undefined}
          onClick={handleClick}
        >
          {currentUser && currentUser.photoURL ? (
            <img src={currentUser.photoURL} alt='user' style={{ height: '30px', width: '30px', borderRadius: '20px' }}/>
          ) : (
            <img
              src="https://static.vecteezy.com/system/resources/thumbnails/020/765/399/small/default-profile-account-unknown-icon-black-silhouette-free-vector.jpg"
              alt='user' style={{ height: '30px', width: '30px', borderRadius: '20px' }}
            />
          )}
          <FontAwesomeIcon icon={faAngleDown} style={{ color: "#000000", margin: '10px' }} />
        </Button>
        <Menu
          id="basic-menu"
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          MenuListProps={{
            'aria-labelledby': 'basic-button',
          }}
          sx={{
            flexDirection: 'column', "& .MuiMenu-paper":
              { backgroundColor: {md: "#ad7ef473", xs: "#b388f3"}, borderRadius: '25px', padding: '10px' }
          }}
          className='user-menu'
        >
          {currentUser ? (<div><MenuItem onClick={handleClose} sx={{ fontSize: '15px' }}><Link to='/profile'><img src={profileIcon} className='icon' />Profile</Link></MenuItem>
          {/* <MenuItem onClick={handleClose} sx={{ fontSize: '15px' }}><img src={editIcon} className='icon' />Edit Profile</MenuItem>
          <MenuItem onClick={handleClose} sx={{ fontSize: '15px' }}><img src={notificationIcon} className='icon' />Notifications</MenuItem> */}
          <MenuItem onClick={handleLogout} sx={{ fontSize: '15px' }}><img src={logoutIcon} className='icon' />Logout</MenuItem></div>) : (
          <MenuItem onClick={handleLogin} sx={{ fontSize: '15px' }}><img src={logoutIcon} className='icon' />Login</MenuItem>
          )}
          
        </Menu>
      </div>
      <LoadingModal isLoading={isLoading} msg={'Logging Out'} />
    </>
  );
}